<template>
  <div class="flex justify-center gap-2">
    <TButton
      v-if="!isTraineeUpgradeLoading"
      color="primary"
      type="text"
      @click="buyTrainee('two')"
      >{{ $t('upgrade.buy.trainee.cta_two_years') }}</TButton
    >
    <TButton
      v-if="!isTraineeUpgradeLoading"
      color="primary"
      type="text"
      @click="buyTrainee('one')"
      >{{ $t('upgrade.buy.trainee.cta_one_year') }}</TButton
    >

    <TLoadingIndicatorSmall v-else class="ml-2" />
  </div>
</template>
<script setup lang="ts">
import {
  TButton,
  TLoadingIndicatorSmall,
} from '@teachino/shared-design-system';
import { $t } from '@teachino/shared-i18n';
import {
  type UpgradeSource,
  useGlobalDependencyProvider,
} from '@teachino/shared-util';
import { ref } from 'vue';
import { useLicense } from './useLicense';

const props = defineProps<{
  source: UpgradeSource;
}>();

const { openProLicenseCheckout } = useLicense();
const di = useGlobalDependencyProvider();
const analytics = di.inject('analytics');
const isTraineeUpgradeLoading = ref(false);
const config = di.inject('config');

async function buyTrainee(years: 'two' | 'one') {
  isTraineeUpgradeLoading.value = true;
  analytics.track('upgrade-start-payment', { source: props.source });
  await openProLicenseCheckout({
    discountId:
      years === 'one'
        ? config.traineeDiscountCode()
        : config.traineeDiscountCode2Year(),
    billingCycle: years === 'one' ? 'YEARLY' : 'TWO_YEARS',
  });
  isTraineeUpgradeLoading.value = false;
}
</script>
